import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'ice',
      d: 'M1.5,-5.5h0.5v0.5h-0.5zM2.5,-3.5h0.5v1h-0.5zM-2.5,-3h0.5v0.5h-0.5zM1.5,-2.5h1v0.5h-1zM0.5,1.5h1.5v1h-1.5z',
    },
    {
      paint: 'bareBranch',
      d: 'M-1.5,-5.5h0.5v0.5h-0.5zM-1.5,-5h1v0.5h-1zM2,-5h0.5v0.5h-0.5zM-1,-4.5h1v0.5h-1zM0.5,-4.5h1.5v0.5h-1.5zM-3.5,-4h0.5v0.5h-0.5zM-1,-4h2.5v0.5h-2.5zM-1,-3.5h2v0.5h-2zM-3,-3h0.5v0.5h-0.5zM-1,-3h1.5v0.5h-1.5zM-2.5,-2.5h3v0.5h-3zM-2,-2h2.5v0.5h-2.5zM1,-2h1.5v0.5h-1.5zM-1.5,-1.5h3.5v0.5h-3.5zM-1,-1h2v0.5h-2zM0,-0.5h0.5v3h-0.5z',
    },
    { paint: 'firewoodLog', d: 'M-0.5,-0.5h0.5v2.5h-0.5z' },
    {
      paint: 'snowCap',
      d: 'M2,-6h0.5v1h-0.5zM1,-5h1v0.5h-1zM-3.5,-4.5h1v0.5h-1zM-3,-4h0.5v0.5h-0.5zM-3,-3.5h1v0.5h-1zM-2,-3h1v0.5h-1zM2,-3h0.5v0.5h-0.5zM-1.5,1.5h1v0.5h-1zM-1.5,2h1.5v0.5h-1.5z',
    },
  ],
  pixels: 88,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'ice', d: 'M-2,-4h0.5v0.5h-0.5zM2,-4h1v0.5h-1zM0.5,1.5h1.5v1h-1.5z' },
    {
      paint: 'bareBranch',
      d: 'M-1,-6h1v1.5h-1zM0.5,-5h0.5v0.5h-0.5zM-1,-4.5h2v0.5h-2zM-2.5,-4h0.5v0.5h-0.5zM-1,-4h1.5v0.5h-1.5zM-2,-3.5h2.5v0.5h-2.5zM-1.5,-3h2v0.5h-2zM2,-3h0.5v0.5h-0.5zM-1,-2.5h3v0.5h-3zM-0.5,-2h2v0.5h-2zM-0.5,-1.5h1.5v0.5h-1.5zM0,-1h0.5v3.5h-0.5z',
    },
    { paint: 'firewoodLog', d: 'M-0.5,-1h0.5v3h-0.5z' },
    {
      paint: 'snowCap',
      d: 'M1,-6h1v0.5h-1zM0.5,-5.5h1v0.5h-1zM-2.5,-5h0.5v0.5h-0.5zM-3,-4.5h2v0.5h-2zM-1.5,-4h0.5v0.5h-0.5zM1.5,-3.5h1v0.5h-1zM1.5,-3h0.5v0.5h-0.5zM-1.5,1.5h1v0.5h-1zM-1.5,2h1.5v0.5h-1.5z',
    },
  ],
  pixels: 78,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: 'ice',
      d: 'M3.5,-5.5h0.5v0.5h-0.5zM-4,-5h0.5v1h-0.5zM1,-5h0.5v0.5h-0.5zM3,-5h0.5v0.5h-0.5zM1.5,-4.5h0.5v0.5h-0.5zM3.5,-3h0.5v0.5h-0.5zM3,-2.5h0.5v0.5h-0.5zM-4,-2h0.5v0.5h-0.5zM-1,1.5h0.5v0.5h-0.5zM1,1.5h1v0.5h-1zM0.5,2h1.5v0.5h-1.5z',
    },
    {
      paint: 'bareBranch',
      d: 'M1,-6h0.5v0.5h-0.5zM-2,-5.5h1v1h-1zM0.5,-5.5h1v0.5h-1zM0.5,-5h0.5v0.5h-0.5zM-2,-4.5h1.5v0.5h-1.5zM0,-4.5h1v0.5h-1zM2,-4.5h1v0.5h-1zM-4,-4h1v0.5h-1zM-1.5,-4h3.5v0.5h-3.5zM-3.5,-3.5h4v0.5h-4zM-2.5,-3h3v0.5h-3zM-1,-2.5h1.5v1h-1.5zM1,-2h2v0.5h-2zM-4,-1.5h6.5v0.5h-6.5zM-2,-1h3.5v0.5h-3.5zM-1,-0.5h0.5v0.5h-0.5zM0,-0.5h0.5v0.5h-0.5zM0,0h1v2h-1zM-1,0.5h0.5v1h-0.5zM0,2h0.5v0.5h-0.5z',
    },
    { paint: 'firewoodLog', d: 'M-0.5,-0.5h0.5v2.5h-0.5z' },
    {
      paint: 'snowCap',
      d: 'M3,-5.5h0.5v0.5h-0.5zM1.5,-5h1.5v0.5h-1.5zM-3.5,-4.5h0.5v0.5h-0.5zM1,-4.5h0.5v0.5h-0.5zM-3,-4h1.5v0.5h-1.5zM3,-3.5h1v0.5h-1zM2.5,-3h1v0.5h-1zM2,-2.5h1v0.5h-1zM-3.5,-2h1.5v0.5h-1.5zM-1.5,1.5h0.5v0.5h-0.5zM-1.5,2h1.5v0.5h-1.5z',
    },
  ],
  pixels: 123,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
